import { Routes } from '@angular/router';
import { LoginPageComponent } from './auth/login-page/login-page.component';
import { AngularFireAuthGuard } from '@angular/fire/compat/auth-guard';
import { HomeContainerComponent } from './home/home-container/home-container.component';
import { RenderPageComponent } from './render-list-page/render-page/render-page.component';
import { EditorContainerComponent } from './editor/editor-container/editor-container.component';
import { DemoContainerComponent } from './editor/demo-container/demo-container.component';
import { TosComponent } from './legal/tos/tos.component';
import { PrivacyComponent } from './legal/privacy/privacy.component';
import { MarketComponent } from './market/market.component';
import { CelebrationComponent } from './shared/celebration/celebration.component';
import { RedirectsComponent } from './redirects/redirects.component';
import { DocsContainerComponent } from './docs/docs-container/docs-container.component';
import { EnterpriseViewComponent } from './enterprise/enterprise-view/enterprise-view.component';
import { EnterpriseEditorContainerComponent } from './enterprise/enterprise-editor-container/enterprise-editor-container.component';
import { EnterpriseAdminViewComponent } from './enterprise/enterprise-admin-view/enterprise-admin-view.component';

export const routes: Routes = [
  {path: 'home', component: HomeContainerComponent},
  {path: 'tos', component: TosComponent},
  {path: 'privacy', component: PrivacyComponent},
  {
    path: 'my-renders',
    component: RenderPageComponent,
    canActivate: [AngularFireAuthGuard],
    children: [{
      path: 'purchase-success',
      component: CelebrationComponent
    }]
  },
  {
    path: 'docs',
    component: DocsContainerComponent,
    children: [{
      path: '**',
      component: DocsContainerComponent
    }]
  },
  {path: 'market', component: MarketComponent, canActivate: [AngularFireAuthGuard]},
  {path: 'enterprise/admin', component: EnterpriseAdminViewComponent, canActivate: [AngularFireAuthGuard]},
  {path: 'enterprise/:id', component: EnterpriseEditorContainerComponent, canActivate: [AngularFireAuthGuard]},
  {path: 'enterprise', component: EnterpriseViewComponent, canActivate: [AngularFireAuthGuard]},
  {path: 'editor/:id', component: EditorContainerComponent, canActivate: [AngularFireAuthGuard]},
  {path: 'demo/:id', component: DemoContainerComponent},
  {path: 'redirects/:linkage', component: RedirectsComponent, pathMatch: 'full'},
  {path: 'login', component: LoginPageComponent},
  {path: 'v4', redirectTo: 'redirects/devforum', pathMatch: 'full'},
  {path: 'quick-start', redirectTo: 'docs/quick-start', pathMatch: 'full'},
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: '**', redirectTo: 'home', pathMatch: 'full'},
];
